import { retryRequestApiSaga } from '@client/common/redux/api/sagas';
import { reportError } from '@client/common/redux/errors/actions';
import { parseError } from '@client/common/utils/api/error';
import { Addresses } from '@client/myAccount/addresses/api/Addresses';
import {
  fetchAddressesSearch,
  fetchAddressesSearchFulfilled,
  fetchAddressesSearchRejected,
} from '@client/myAccount/addresses/redux/addressesSearch/redux';
import { AxiosResponse } from 'axios';
import { all, AllEffect, call, CallEffect, ForkEffect, put, PutEffect, takeLatest } from 'redux-saga/effects';
import { AddressesType } from 'b2b-common/core/account/api/Address.types';

function* addressesSearchSaga(
  action: ReturnType<typeof fetchAddressesSearch>,
): Generator<CallEffect | PutEffect, any, AxiosResponse<AddressesType>> {
  const { searchQuery } = action.payload;

  try {
    const response = yield call(
      retryRequestApiSaga,
      Addresses.fetch({
        pageSize: 50,
        startItem: 0,
        searchQuery,
      }),
    );
    yield put(fetchAddressesSearchFulfilled(response.data));
  } catch (error) {
    yield put(fetchAddressesSearchRejected(parseError(error)));
    yield put(reportError({ message: action.type, error, additionalData: action.payload }));
  }
}

export function* addressesSearchSagas(): Generator<AllEffect<ForkEffect>, void> {
  yield all(
    [
      takeLatest(fetchAddressesSearch.type, addressesSearchSaga),
    ],
  );
}
